import React, { FC, useEffect } from 'react';

import { DefaultButton, TextField, PrimaryButton } from '@fluentui/react';
import { Stack, IStackStyles, IStackProps } from '@fluentui/react/lib/Stack';
import strings from '../../../loc/strings';
import FnPEditor from '../CKEditor/FnPEditor';
import { fetchReminder, HandleUpdateReminder } from "../../../services/AdminServices/ReminderService";
import { MailNotificationItem } from '../../../model/MailNotificationItem';
import { displayMessageBar } from '../../LayoutWithAuth/LayoutWithAuth';
import { useAuth } from "react-oidc-context";
import { MessageBarType } from "@fluentui/react";



const stackStyles: Partial<IStackStyles> = { root: { width: 650 } };
const stackTokens = { childrenGap: 50 };

const columnProps: Partial<IStackProps> = {
    tokens: { childrenGap: 15 },
    styles: { root: { padding: 10 } },
};
const buttonStyles: Partial<IStackStyles> = {
    root: {
        width: '150px',
        alignSelf: 'end'
    },
};



function Reminder() {
    const auth = useAuth();
    const [items, setItems] = React.useState<MailNotificationItem>();
    const [mailContent, setMailContent] = React.useState('');
    const [error, setError] = React.useState<string>('false');

    useEffect(() => {
        (async function () {
            // Clear any existing error message
            displayMessageBar(MessageBarType.info, "", false);

            const result = await fetchReminder("1", auth.user?.id_token);

            // Check if the result is an error
            if ('errors' in result) {
                // Handle validation errors
                const errorMessages = result.errors?.join(', ') || result.message || 'An error occurred while fetching reminder';
                setError('Error fetching reminder');
                displayMessageBar(MessageBarType.error, errorMessages, false);
                return;
            }

            const response = result as MailNotificationItem;
            setItems(response);
            setMailContent(response?.mailbody);
        })();
    }, [])


    const handleItemsProcessed = (processedData: any) => {
        // Update the items state with the processed data
        if (processedData.length > 0) {

            setMailContent(processedData);
        } else {

            setError('The Reminder is empty');
        }
    };
    function escapeDoubleQuotes(inputString: any) {
        return inputString.replaceAll('"', '\\"');
    }
    function handleupdate(): void {
        const escapedText = escapeDoubleQuotes(mailContent);

        const UpdateReminder = async () => {
            // Clear any existing error message
            displayMessageBar(MessageBarType.info, "", false);

            try {
                const response = await HandleUpdateReminder(escapedText, auth.user?.id_token);

                // Check if the response is a Response object (success case)
                if ('ok' in response && response.ok) {
                    displayMessageBar(MessageBarType.success, "The Mail body text is updated successfully.", false);
                } 
                // Check if the response is an error
                else if ('errors' in response || 'message' in response) {
                    // Handle validation errors
                    const errorMessages = response.errors?.join(', ') || response.message || 'An error occurred while updating reminder';
                    displayMessageBar(MessageBarType.error, errorMessages, false);
                } 
                // Fallback error case
                else {
                    displayMessageBar(MessageBarType.error, "Error updating Reminder Mail body.", false);
                }
            } catch (error: any) {
                console.error(`Error update MailBody: ${error.message}`);
                displayMessageBar(MessageBarType.error, `Error updating Reminder Mail body: ${error.message}`, false);
            }
        };

        UpdateReminder();
    }




    return (

        <Stack  {...columnProps}>
            <FnPEditor data={mailContent} onItemsProcessed={handleItemsProcessed} error={error} />
            <PrimaryButton text={strings.admineditbtntest} styles={buttonStyles} onClick={handleupdate} />

        </Stack>
    );
}


export default Reminder;
